import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

@Component({
  name: 'TkDialog',
})
class TkDialog extends Vue {
  // #region [ DATA ]
  private showDialog = false;
  private title: string = '';
  private description: string = '';
  private descriptionHtmlRenderization = false;
  private alertMode = false;
  private resolve: () => void = null;
  private reject: () => void = null;
  private acceptCallback: () => void = null;
  private declineCallback: () => void = null;
  //#endregion

  // #region [ METHODS ]
  public show(
    title: string,
    description: string,
    acceptCallback: () => void = null,
    declineCallback: () => void = null,
    descriptionHtmlRenderization: boolean = false,
    alertMode: boolean = false,
  ): Promise<void> {
    this.showDialog = true;
    this.title = title;
    this.description = description;
    this.descriptionHtmlRenderization = descriptionHtmlRenderization;
    this.alertMode = alertMode;
    this.acceptCallback = acceptCallback;
    this.declineCallback = declineCallback;

    const promise: Promise<void> = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    return promise;
  }

  public hide() {
    this.showDialog = false;
  }

  private accept() {
    this.showDialog = false;

    if (this.acceptCallback) {
      this.acceptCallback();
    }

    this.resolve();
  }

  private decline() {
    this.showDialog = false;

    if (this.declineCallback) {
      this.declineCallback();
    }
  }
  // #endregion
}

export default TkDialog;